module.exports = __webpack_public_path__ + "img/p.f6869793.jpg";